import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComprobanteService } from 'src/app/shared/services/comprobante/comprobante.service';
import { ErrorService } from 'src/app/shared/services/error/error.service';
import {
  AUTO_STYLE,
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

const DEFAULT_DURATION = 300;


@Component({
  selector: 'app-comprobantes-view',
  templateUrl: './comprobantes-view.component.html',
  styleUrls: ['./comprobantes-view.component.scss'],
  /* PM Animacion de la apertura de detalles de montos del comprobante */
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ]
})
export class ComprobantesViewComponent implements OnInit {
  @Input() comprobanteId: number;
  @Input() tipoComprobante: string = '';

  public formComprobante: FormGroup;
  public pjeDescuento: number = 0;
  public totalGravado: any;
  public totalIva: any;
  public comprobante: any = {Numero : '', Articulos: [], Moneda:{ 'Nombre' : ''}};
  public masInfo: boolean = true;
  public masDatos: boolean = true;
  public masTributos: boolean = true; 
  public masIva: boolean = true;
  public ocultarPreciosUnit: boolean = true;
  public simboloMoneda: string = '$ ';
  constructor(public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private comprobanteService: ComprobanteService,
    private errorService: ErrorService,) { 
      this.formComprobante = this.fb.group({
        Fecha: [''],
        Numero: [''],
        FormaPago: [''],
        TipoComp: [''],
        Descuento:[''], 
        Importe: [''],
        SubtotalNeto: [''],
        SubtotalFinal: [''],
        Sucursal: [''],
        Deposito: [''],
        TotalGravado: [''], 
        TotalIva: [''], 
        TotalNoGravado: [''], 
        ImpInterno : [''], 
        Exento: [''],
        PercIva: [''],
        PercIibb: [''],
        Tributos: [''],
        Observacion: [''],
        FechaEntrega: [''],
        DireccionEntrega: ['']
      })
   }

  ngOnInit(): void {
    // Ocultamos los precios unitarios si el tipo de comprobante es remito
    this.ocultarPreciosUnit = (this.tipoComprobante == 'remito');
    this.onSearch();
  }

  loadForm(){
    if (this.comprobante !== undefined){
      this.pjeDescuento = this.comprobante.PjeDescuento;
      
      let desc : any = 0;
      let tributoTotal : any = 0;
      let total : any = 0;
      let tipoComp = '';
      let fechaVencimiento = '';
      let importeAcopiar = '0,00';
      let importe = '0,00';
      let subTotalNeto = '0,00';
      let subTotalFinal = '0,00';
      let totalGravado = '0,00';
      let totalIva = '0,00';
      let descuento = '0,00';
      let noGravado = '0,00';
      let impuestoInterno = '0,00';
      let exento = '0,00';
      let percepcion = '0,00';
      let retPer = '0,00';
      let tributos = '0,00';
      let fechaEntrega = '';
      let direccionEntrega = '';

      importe = this.formatZero(this.comprobante.Total);
      desc = ((this.pjeDescuento * this.comprobante.Subtotal) / 100) * -1;
      total = this.comprobante.Total - desc;
      descuento = this.formatZero(desc);
      subTotalNeto = this.formatZero(this.comprobante.Subtotal); 
      subTotalFinal = this.formatZero(total);

      this.calcularGravado(this.comprobante.MontoGravado);

      totalGravado = this.formatZero(this.totalGravado);
      totalIva = this.formatZero(this.totalIva); 

      if ((this.comprobante.MontoNoGravado !== undefined) && (this.comprobante.MontoNoGravado.length > 0)){
        noGravado = this.formatZero(this.comprobante.MontoNoGravado[0].NoGravado);
        impuestoInterno = this.formatZero(this.comprobante.MontoNoGravado[0].ImpuestoInterno);
        exento = this.formatZero(this.comprobante.MontoNoGravado[0].Exento);
        percepcion = this.formatZero(this.comprobante.MontoNoGravado[0].Percepcion);
        retPer = this.formatZero(this.comprobante.MontoNoGravado[0].RetPer);
        tributoTotal = this.comprobante.MontoNoGravado[0].Percepcion + this.comprobante.MontoNoGravado[0].RetPer + this.comprobante.MontoNoGravado[0].ImpuestoInterno;
        tributos = this.formatZero(tributoTotal);
      }

      tipoComp = this.comprobante.TipoComprobante.Nombre + ' ' + this.comprobante.LetraComprobante;
      if(this.tipoComprobante == 'remito'){
        if (this.comprobante.DatosRemito != undefined){
          fechaEntrega = this.comprobante.DatosRemito.FechaEntrega + ' ' + this.comprobante.DatosRemito.HoraEntrega;
          direccionEntrega = this.comprobante.DatosRemito.DireccionEntrega; 
        }
      }
      if(this.tipoComprobante == 'pendiente'){
        if (this.comprobante.DatosAcopio != undefined){
          fechaVencimiento = this.comprobante.DatosAcopio.FechaVencimiento;;
          importeAcopiar = this.formatZero(this.comprobante.DatosAcopio.Importe);
          tipoComp = 'Acopio (' + tipoComp + ')';
        }else{
          tipoComp = 'Pendiente de despacho (' + tipoComp + ')';  
        }
      }
      this.formComprobante = this.fb.group({
        Fecha: [this.comprobante.Fecha],
        Numero: [this.comprobante.Numero],
        FormaPago: [this.comprobante.FormaPago.Nombre],
        TipoComp: [tipoComp],
        Descuento: [descuento], 
        Importe: [importe],
        FechaVencimiento: [fechaVencimiento],
        ImporteAcopiar: [importeAcopiar],
        SubtotalNeto: [subTotalNeto],
        SubtotalFinal: [subTotalFinal],
        Sucursal: [this.comprobante.Sucursal.Nombre],
        Deposito: [this.comprobante.Deposito.Nombre],
        TotalGravado: [totalGravado],
        TotalIva: [totalIva], 
        TotalNoGravado: [noGravado],
        ImpInterno: [impuestoInterno],
        Exento: [exento], 
        PercIva: [percepcion],
        PercIibb: [retPer],
        Tributos: [tributos],
        Observacion: [this.comprobante.Detalle],
        FechaEntrega: [fechaEntrega],
        DireccionEntrega: [direccionEntrega]
      }) 
    }
  }

  /* PM Funcion que dado el arreglo de gravados, realiza el calculo de totalgravado y totalIva*/
  calcularGravado(gravados: any){
    this.totalGravado = 0;
    this.totalIva = 0;

    gravados.forEach(element => {
      this.totalGravado += element.Gravado;
      this.totalIva += element.MontoIva;  
    });
  }

  /* PM Funcion que dado un numero, retorna un string dandole formato a los decimales y a valores cero */
  formatZero(numero: any): string{
    if (numero == '0'){
      return '0,00';
    }else{
      if (numero % 1 == 0){
        return new Intl.NumberFormat('es-AR').format(numero.toFixed(2)) + ',00';
      }else{
        return new Intl.NumberFormat('es-AR').format(numero.toFixed(2));
      }
    }
  }

  onSearch() {
    const susc = this.comprobanteService.getComprobanteId(this.comprobanteId).subscribe(
      (data:any) => {
        if (data.Data !== undefined){
          this.comprobante = data.Data;
          console.log(this.comprobante);
          this.simboloMoneda = this.comprobante.Moneda.Simbolo;
          this.loadForm();
        }
      },
      (error: any) => {
        this.errorService.getError(error.status);
      }
    );
    susc.unsubscribe;
  }

  //PM Metodos que ocultan o muestran los toggles de informacion de valores
  toggleMasInfo(index: number) {
    this.masTributos = true;
    this.masIva = true;
    this.masDatos = true;
    this.masInfo = !this.masInfo;
  } 

  toggleMasIva(index: number){
    this.masIva = !this.masIva;
  }

  toggleTributos(index: number) {
    this.masTributos = !this.masTributos;
  } 

  toggleMasDatos(index: number){
    this.masDatos = !this.masDatos;
  }

  //PM Ciertos componentes del front se deben mostrar si el comprobante no es remito ni presupuesto
  mostrarComponente(onlyRemito: boolean) : boolean {
    if (onlyRemito){
      return (this.tipoComprobante !== 'remito')
    }else{
      return ((this.tipoComprobante !== 'remito') && (this.tipoComprobante !== 'presupuesto'))
    }
    
  }
}
